<div class="dialog-content">

	<div class="header">
		<span>{{ "ALARM_DETAILS.ALARM_DETAILS" | translate }}</span>
		<nb-icon nbPrefix icon="close-outline" pack="eva" class="close-dialog" (click)="closeDialog()">
		</nb-icon>
	</div>

	<div class="alarm-details">
		<table class="details-table" aria-label="alarm-info">
			<tbody>
				<tr>
					<th scope="row">{{ "REPORT_DETAIL.ALARM_ID" | translate }}</th>
					<td>{{ alarm?.shortAlarmId }}</td>
					<th scope="row">{{ "REPORT_DETAIL.ALARM_TYPE" | translate }}</th>
					<td>{{ alarm?.alarmType }}</td>
				</tr>
				<tr>
					<th scope="row">{{ "REPORT_DETAIL.AREA_NAME" | translate }}</th>
					<td>{{ alarm?.branch?.areaName }}</td>
					<th scope="row">{{ "REPORT_DETAIL.BRANCH_NAME" | translate }}</th>
					<td>{{ alarm?.branch?.branchName }}</td>
				</tr>
				<tr>
					<th scope="row">{{ "REPORT_DETAIL.STATUS" | translate }}</th>
					<td>{{ alarm?.status }}</td>
					<th scope="row">{{ "REPORT_DETAIL.ACTIVATION_TIME" | translate }}</th>
					<td>{{ getGmtTime(alarm?.activationTime) }}</td>
				</tr>
				<tr>
					<th scope="row">{{ "REPORT_DETAIL.LONGITUDE" | translate }}</th>
					<td>{{ alarm?.branch?.location?.longitude }}</td>
					<th scope="row">{{ "REPORT_DETAIL.LATITUDE" | translate }}</th>
					<td>{{ alarm?.branch?.location?.latitude }}</td>
				</tr>
				<tr>
					<th scope="row">{{ "REPORT_DETAIL.ESCALATED_BY" | translate }}</th>
					<td>{{ getUserName(alarm?.escalatedBy?.firstName, alarm?.escalatedBy?.lastName) }}</td>
					<th scope="row">{{ "REPORT_DETAIL.ESCALATED_TO" | translate }}</th>
					<td>{{ getUserName(alarm?.escalatedTo?.firstName, alarm?.escalatedTo?.lastName) }}</td>
				</tr>
				<tr>
					<th scope="row">{{ "REPORT_DETAIL.VERIFY_BY" | translate }}</th>
					<td>{{ getUserName(alarm?.verifiedBy?.firstName, alarm?.verifiedBy?.lastName) }}</td>
					<th scope="row">{{ "REPORT_DETAIL.VERIFY_FROM" | translate }}</th>
					<td>{{ getUserName(alarm?.verifiedFrom?.firstName, alarm?.verifiedFrom?.lastName) }}</td>
				</tr>
				<tr>
					<th scope="row">{{ "ANALYTICAL_ALARM_HISTORY.ASSIGNED_BY" | translate }}</th>
					<td>{{ getUserName(alarm?.assignedBy?.firstName, alarm?.assignedBy?.lastName) }}</td>
					<th scope="row">{{ "ANALYTICAL_ALARM_HISTORY.ASSIGNED_TO" | translate }}</th>
					<td>{{ getUserName(alarm?.assignedTo?.firstName, alarm?.assignedTo?.lastName) }}</td>
				</tr>
				<tr>
					<th scope="row">{{ "REPORT_DETAIL.RESOLVED_BY" | translate }}</th>
					<td>{{ getUserName(alarm?.resolvedBy?.firstName, alarm?.resolvedBy?.lastName) }}</td>
					<th scope="row">{{ "REPORT_DETAIL.LAST_ACTION_TIME" | translate }}</th>
					<td>{{ getGmtTime(alarm?.lastactiontime) }}</td>
				</tr>
				<tr class="alarm-info-row">
					<th scope="row">{{ "REPORT_DETAIL.ALARM_INFO" | translate }}</th>
					<td colspan="3">{{ getAlarmInfo(alarm?.info) }}</td>
				</tr>
			</tbody>
		</table>
	</div>

	<div class="action-history">
		<div class="header">{{ "ACTION_HISTORY.ACTION_HISTORY" | translate }}</div>

		<div class="history-table-wrap" *ngIf="actions && actions.length > 0; else noActions">
			<table mat-table [dataSource]="actions" class="history-table">
				<ng-container matColumnDef="timeStamp">
					<th mat-header-cell *matHeaderCellDef>{{ "ACTION_HISTORY.DATE_TIME" | translate }}</th>
					<td mat-cell *matCellDef="let element" class="time-data">
						{{ getDate(element.timeStamp) }}
					</td>
				</ng-container>

				<ng-container matColumnDef="message">
					<th mat-header-cell *matHeaderCellDef>{{ "ACTION_HISTORY.ACTION" | translate }}</th>
					<td mat-cell *matCellDef="let element" class="action-data" matTooltip="{{ element.action }}">
						{{ element.action }}
						<i class="fa fa-picture-o photo-icon" aria-hidden="true" *ngIf="element.type === 'photo'"
							(click)="displayMedia(element)"></i>
						<i class="fa fa-play-circle-o video-icon" aria-hidden="true" *ngIf="element.type === 'video'"
							(click)="displayMedia(element)"></i>
						<audio *ngIf="element.type === 'audio'" alt="audio" controls>
							<source [src]="element.url" type="audio/mp3" />
						</audio>
					</td>
				</ng-container>

				<ng-container matColumnDef="name">
					<th mat-header-cell *matHeaderCellDef>{{ "ACTION_HISTORY.NAME" | translate }}</th>
					<td mat-cell *matCellDef="let element" class="name-data"
						[matTooltip]="element.user?.firstName + ' ' + element.user?.lastName">
						{{ element.user.firstName + ' ' + element.user.lastName }}
					</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
			</table>
		</div>

		<ng-template #noActions>
			<div class="box-content-no-data">
				{{ 'ALARM_HISTORY.NO_DATA' | translate }}
			</div>
		</ng-template>
	</div>

	<button class="btn" type="button" (click)="getAlarmReport()">
		{{ "FILTER_DATA.GET_FULL_REPORT_LINK" | translate }}
	</button>
</div>
